import React from 'react';
import { 
  PieChart, Pie, Cell, 
  BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer,
  Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis
} from 'recharts';

export default function InventoryDashboard() {
  // Mock Data
  const stockLevels = [
    { name: 'In Stock', value: 75, color: '#3B82F6' },
    { name: 'Low Stock', value: 15, color: '#EF4444' },
    { name: 'Out of Stock', value: 10, color: '#991B1B' },
  ];

  const warehouseUtilization = [
    { name: 'Used', value: 88, color: '#06B6D4' },
    { name: 'Free', value: 12, color: '#E5E7EB' },
  ];

  const turnoverData = [
    { name: 'May 2026', value: 50 },
    { name: 'Jun 2026', value: 85 },
    { name: 'Jul 2026', value: 70 },
  ];

  const rateData = [
    { name: 'May 2026', value: 15 },
    { name: 'Jun 2026', value: 12 },
    { name: 'Jul 2026', value: 13 },
  ];

  const topItems = [
    { sku: 'B800001', name: 'Product Name 1...', stock: 100, status: 'In Stock (Green)', statusColor: '#059669', reorder: 30 },
    { sku: 'B800002', name: 'Product Name 2...', stock: 15, status: 'Low Stock (Orange)', statusColor: '#D97706', reorder: 10 },
    { sku: 'B800003', name: 'Product Name 3...', stock: 15, status: 'Low Stock (Orange)', statusColor: '#D97706', reorder: 10 },
    { sku: 'B800004', name: 'Product Name 4...', stock: 100, status: 'Low Stock (Orange)', statusColor: '#D97706', reorder: 10 },
    { sku: 'B800001', name: 'Product Name 5...', stock: 75, status: 'In Stock (Green)', statusColor: '#059669', reorder: 30 },
    { sku: 'B800002', name: 'Product Name 7...', stock: 10, status: 'In Stock (Green)', statusColor: '#059669', reorder: 10 },
  ];

  const radarData = [
    { subject: 'Pricing', Supplier1: 40, Supplier2: 50, Supplier3: 30, Supplier24: 60, Communication: 45 },
    { subject: 'Communication', Supplier1: 50, Supplier2: 45, Supplier3: 40, Supplier24: 55, Communication: 50 },
    { subject: 'Delivery Speed', Supplier1: 35, Supplier2: 60, Supplier3: 50, Supplier24: 40, Communication: 30 },
    { subject: 'Product Quality', Supplier1: 60, Supplier2: 40, Supplier3: 55, Supplier24: 45, Communication: 60 },
  ];

  return (
    <div style={{ padding: '24px', backgroundColor: '#F9FAFB', minHeight: '100vh', fontFamily: 'Inter, sans-serif' }}>
      
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <h1 style={{ fontSize: '28px', fontWeight: 'bold', color: '#111827', margin: 0 }}>Overview</h1>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{ padding: '6px 12px', borderRadius: '8px', border: '1px solid #E5E7EB', backgroundColor: '#fff', fontSize: '13px', color: '#4B5563', display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
            All Entities <span style={{ fontSize: '10px' }}>▼</span>
          </div>
          <div style={{ padding: '6px 12px', borderRadius: '8px', border: '1px solid #E5E7EB', backgroundColor: '#fff', fontSize: '13px', color: '#4B5563', display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
            May 1, 2026 - May 31, 2026 <span style={{ fontSize: '10px' }}>▼</span>
          </div>
        </div>
      </div>

      {/* Top Row KPI Cards */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '20px' }}>
        
        {/* Card 1: Product Stock Levels */}
        <div style={{ backgroundColor: '#fff', padding: '16px', borderRadius: '12px', border: '1px solid #E5E7EB', display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div style={{ fontSize: '14px', color: '#111827', fontWeight: '600', marginBottom: '8px' }}>Product Stock Levels</div>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ width: '120px', height: '120px', position: 'relative' }}>
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie data={stockLevels} innerRadius={35} outerRadius={55} dataKey="value" stroke="#fff" strokeWidth={2}>
                    {stockLevels.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
              <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#fff' }}></span>
              </div>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'center', marginTop: '8px' }}>
              {stockLevels.map((item, idx) => (
                <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '11px', color: '#4B5563' }}>
                  <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: item.color }}></div>
                  {item.name}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Card 2: Warehouse Utilization */}
        <div style={{ backgroundColor: '#fff', padding: '16px', borderRadius: '12px', border: '1px solid #E5E7EB', display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div style={{ fontSize: '14px', color: '#111827', fontWeight: '600', marginBottom: '8px' }}>Warehouse Utilization</div>
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-end', position: 'relative' }}>
            <div style={{ width: '160px', height: '90px' }}>
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie 
                    data={warehouseUtilization} 
                    cx="50%" cy="100%" 
                    startAngle={180} endAngle={0} 
                    innerRadius={60} outerRadius={80} 
                    dataKey="value" stroke="none"
                  >
                    {warehouseUtilization.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </div>
            <div style={{ position: 'absolute', bottom: '10px', fontSize: '28px', fontWeight: 'bold', color: '#111827' }}>
              88%
            </div>
          </div>
        </div>

        {/* Card 3: Avg Delivery Time & Turnover Rate */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', height: '100%' }}>
          <div style={{ backgroundColor: '#fff', padding: '12px 16px', borderRadius: '12px', border: '1px solid #E5E7EB', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <div style={{ fontSize: '13px', color: '#111827', fontWeight: '600', marginBottom: '8px' }}>Average Delivery Time</div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#111827' }}>3.2 Days</div>
              <div style={{ width: '28px', height: '28px', backgroundColor: '#E0F2FE', color: '#0284C7', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>
              </div>
            </div>
          </div>
          <div style={{ backgroundColor: '#fff', padding: '16px', borderRadius: '12px', border: '1px solid #E5E7EB', display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
            <div style={{ fontSize: '13px', color: '#111827', fontWeight: '600', marginBottom: '12px' }}>Inventory Turnover Rate</div>
            <div style={{ flex: 1, minHeight: 0 }}>
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={turnoverData} margin={{ top: 0, right: 0, left: -20, bottom: 0 }}>
                  <CartesianGrid strokeDasharray="0" vertical={false} stroke="#E5E7EB" />
                  <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fontSize: 9, fill: '#6B7280' }} dy={5} />
                  <YAxis axisLine={false} tickLine={false} tick={{ fontSize: 9, fill: '#6B7280' }} ticks={[0, 20, 40, 60, 80, 100]} domain={[0, 100]} />
                  <Bar dataKey="value" radius={[2, 2, 0, 0]} barSize={24}>
                    {turnoverData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={index === 0 ? '#6366F1' : (index === 1 ? '#818CF8' : '#06B6D4')} />
                    ))}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>

        {/* Card 4: Order Fulfillment & Rate */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', height: '100%' }}>
          <div style={{ backgroundColor: '#fff', padding: '12px 16px', borderRadius: '12px', border: '1px solid #E5E7EB', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <div style={{ fontSize: '13px', color: '#111827', fontWeight: '600', marginBottom: '8px' }}>Order Fulfillment Rate</div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#111827' }}>96%</div>
              <div style={{ width: '28px', height: '28px', backgroundColor: '#EDE9FE', color: '#6B46C1', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"></polyline></svg>
              </div>
            </div>
          </div>
          <div style={{ backgroundColor: '#fff', padding: '16px', borderRadius: '12px', border: '1px solid #E5E7EB', display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
            <div style={{ fontSize: '13px', color: '#111827', fontWeight: '600', marginBottom: '12px' }}>Rate</div>
            <div style={{ flex: 1, minHeight: 0 }}>
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={rateData} margin={{ top: 0, right: 0, left: -20, bottom: 0 }}>
                  <CartesianGrid strokeDasharray="0" vertical={false} stroke="#E5E7EB" />
                  <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fontSize: 9, fill: '#6B7280' }} dy={5} />
                  <YAxis axisLine={false} tickLine={false} tick={{ fontSize: 9, fill: '#6B7280' }} ticks={[0, 10, 20]} domain={[0, 20]} />
                  <Bar dataKey="value" radius={[2, 2, 0, 0]} barSize={24}>
                    {rateData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={index === 0 ? '#6366F1' : (index === 1 ? '#3B82F6' : '#06B6D4')} />
                    ))}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>

      </div>

      {/* Bottom Row */}
      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1.2fr', gap: '16px' }}>
        
        {/* Stock Status Table */}
        <div style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '12px', border: '1px solid #E5E7EB', display: 'flex', flexDirection: 'column' }}>
          <div style={{ fontSize: '15px', fontWeight: '600', color: '#111827', marginBottom: '16px' }}>Stock Status (Top Items)</div>
          <div style={{ flex: 1 }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '12px' }}>
              <thead>
                <tr style={{ borderBottom: '1px solid #F3F4F6' }}>
                  <th style={{ paddingBottom: '12px', fontWeight: '600', color: '#111827' }}>Product SKU</th>
                  <th style={{ paddingBottom: '12px', fontWeight: '600', color: '#111827' }}>Product Name</th>
                  <th style={{ paddingBottom: '12px', fontWeight: '600', color: '#111827' }}>Current Stock</th>
                  <th style={{ paddingBottom: '12px', fontWeight: '600', color: '#111827' }}>Status</th>
                  <th style={{ paddingBottom: '12px', fontWeight: '600', color: '#111827' }}>Reorder Level</th>
                </tr>
              </thead>
              <tbody>
                {topItems.map((item, index) => (
                  <tr key={index} style={{ borderBottom: index < topItems.length - 1 ? '1px solid #F3F4F6' : 'none' }}>
                    <td style={{ padding: '12px 0', color: '#4B5563' }}>{item.sku}</td>
                    <td style={{ padding: '12px 0', color: '#111827' }}>{item.name}</td>
                    <td style={{ padding: '12px 0', color: '#4B5563' }}>{item.stock}</td>
                    <td style={{ padding: '12px 0', color: item.statusColor }}>{item.status}</td>
                    <td style={{ padding: '12px 0', color: '#4B5563' }}>{item.reorder}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Supplier Performance */}
        <div style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '12px', border: '1px solid #E5E7EB', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div style={{ fontSize: '15px', fontWeight: '600', color: '#111827', width: '100%', marginBottom: '16px' }}>Supplier Performance</div>
          <div style={{ width: '100%', display: 'flex', flexWrap: 'wrap', gap: '12px', fontSize: '11px', marginBottom: '16px', color: '#4B5563' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}><div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#6366F1' }}></div> Supplier 1</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}><div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#3B82F6' }}></div> Supplier 2</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}><div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#F59E0B' }}></div> Supplier 3</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}><div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#10B981' }}></div> Supplier 24</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}><div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#06B6D4' }}></div> Communication</div>
          </div>
          <div style={{ width: '100%', height: '220px' }}>
            <ResponsiveContainer width="100%" height="100%">
              <RadarChart outerRadius={80} data={radarData}>
                <PolarGrid stroke="#E5E7EB" />
                <PolarAngleAxis dataKey="subject" tick={{ fill: '#4B5563', fontSize: 10 }} />
                <PolarRadiusAxis angle={30} domain={[0, 60]} tick={false} axisLine={false} />
                <Radar name="Supplier 1" dataKey="Supplier1" stroke="#6366F1" fill="#6366F1" fillOpacity={0.3} />
                <Radar name="Supplier 2" dataKey="Supplier2" stroke="#3B82F6" fill="#3B82F6" fillOpacity={0.2} />
              </RadarChart>
            </ResponsiveContainer>
          </div>
        </div>

      </div>

    </div>
  );
}
